import { c as _c } from "react/compiler-runtime";
import { api } from "@agroproj/backend/convex/_generated/api";
import { useQuery } from "convex/react";
import { useConvexAuthReady } from "@/hooks/use-convex-auth-ready";

/**
 * Hook to check if current user has admin privileges
 * Queries the Convex backend for the user's role instead of relying on Clerk session claims.
 * Skips the query when auth is not ready (e.g. during token refresh on window focus)
 * to avoid [NO_IDENTITY] errors.
 */
export function useIsAdmin() {
  const $ = _c(2);
  const {
    canQuery
  } = useConvexAuthReady();
  let t0;
  if ($[0] !== canQuery) {
    t0 = canQuery ? {} : "skip";
    $[0] = canQuery;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isAdmin = useQuery(api.users.queries.isAdmin, t0);
  return isAdmin ?? false;
}